// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"b0b54d1c","230":"9080c864","305":"46c705da","358":"fff0e99f","412":"9787c1a7","436":"753b81dd","470":"e34cad36","505":"572c7195","531":"c9de638a","615":"c1ee69ed","852":"aa95fabf","920":"a174890a","980":"380c61ab"}[chunkId] + ".chunk.js";
};